'use es6';

import { EERIE, SLINKY } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { APPLE_EMAIL_PRIVACY_URL } from '../constants/appleEmailPrivacy';
import { isOperatorAffectedByEmailPrivacy, operatorIsMarketingEmailOpenOperator } from '../utilities/isAffectedByEmailPrivacy';
import FilterOperatorType from './propTypes/FilterOperatorType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AppleEmailPrivacyWarning = props => {
  const {
    condition,
    isReadOnly
  } = props;
  const isAffectedByEmailPrivacy = condition && isOperatorAffectedByEmailPrivacy(condition);
  if (!isAffectedByEmailPrivacy) {
    return null;
  }
  const className = 'display-flex' + (operatorIsMarketingEmailOpenOperator(condition) ? " m-bottom-1" : "");
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    style: {
      gap: '4px',
      lineHeight: '18px'
    },
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIStatusDot, {
        use: "warning"
      }), /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.AppleEmailPrivacyWarning.filterWarning",
          style: {
            color: SLINKY
          }
        })
      })]
    }), isReadOnly && /*#__PURE__*/_jsx("div", {
      className: "align-self-center",
      children: /*#__PURE__*/_jsx(Tooltip, {
        maxInlineSize: "320px",
        placement: "bottom",
        title: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFilters.AppleEmailPrivacyWarning.infoIcon.description"
            })
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              elements: {
                Link: UILink
              },
              message: "customerDataFilters.AppleEmailPrivacyWarning.infoIcon.link_jsx",
              options: {
                external: true,
                href: APPLE_EMAIL_PRIVACY_URL
              }
            })
          })]
        }),
        use: "longform",
        children: /*#__PURE__*/_jsx(UIIcon, {
          color: EERIE,
          "data-test-id": "info-icon",
          name: "info"
        })
      })
    })]
  });
};
AppleEmailPrivacyWarning.propTypes = {
  condition: FilterOperatorType.isRequired,
  isReadOnly: PropTypes.bool
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
AppleEmailPrivacyWarning.defaultProps = {
  isReadOnly: false
};
export default AppleEmailPrivacyWarning;